import { z } from 'zod';
import { InsightSeveritySchema, InsightTypeSchema } from './enums';
import { IdSchema } from './validation';

const text = (max: number) => z.string().trim().min(1).max(max);

export const AiInsightItemSchema = z.object({
  type: InsightTypeSchema,
  severity: InsightSeveritySchema,
  title: text(160),
  description: text(600),
  evidence: z.array(text(300)).max(6),
  recommendedActions: z.array(text(300)).max(5),
});
export type AiInsightItem = z.infer<typeof AiInsightItemSchema>;

export const AiRecommendedContentSchema = z.object({
  title: text(160),
  reason: text(300),
  target: text(120),
});
export type AiRecommendedContent = z.infer<typeof AiRecommendedContentSchema>;

/** Contrato de saída estruturada exigido do Gemini (validado com Zod). */
export const AiInsightOutputSchema = z.object({
  summary: text(800),
  insights: z.array(AiInsightItemSchema).max(8),
  recommendedContent: z.array(AiRecommendedContentSchema).max(6),
});
export type AiInsightOutput = z.infer<typeof AiInsightOutputSchema>;

/** Narrativa para relatórios gerados com IA. */
export const AiReportNarrativeSchema = z.object({
  executiveSummary: text(1500),
  highlights: z.array(text(400)).max(6),
  concerns: z.array(text(400)).max(6),
  recommendations: z.array(text(400)).max(6),
  limitations: text(600),
});
export type AiReportNarrative = z.infer<typeof AiReportNarrativeSchema>;

export const AiInsightSourceSchema = z.enum(['AI', 'FALLBACK']);

export const AiInsightSnapshotSchema = z.object({
  id: z.string(),
  scope: z.enum(['SCHOOL', 'CLASS']),
  classId: z.string().nullable(),
  academicYearId: z.string(),
  termId: z.string().nullable(),
  model: z.string(),
  source: AiInsightSourceSchema,
  summary: z.string(),
  insights: z.array(AiInsightItemSchema),
  recommendedContent: z.array(AiRecommendedContentSchema),
  createdAt: z.string(),
  expiresAt: z.string().nullable(),
});
export type AiInsightSnapshot = z.infer<typeof AiInsightSnapshotSchema>;

export const GenerateInsightsSchema = z.object({
  academicYearId: IdSchema.optional(),
  termId: IdSchema.optional(),
  classId: IdSchema.optional(),
});
export type GenerateInsightsInput = z.infer<typeof GenerateInsightsSchema>;

export const InsightsQuerySchema = GenerateInsightsSchema;
